import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// --- שינוי מרכזי: ייבוא גרסת ה-RTL של Bootstrap ---
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
// ייבוא CSS של FontAwesome
import '@fortawesome/fontawesome-svg-core/styles.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
